// components/templates/sections/TestimonialsSection.tsx
'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import Image from 'next/image';
import { useDesign } from '@/context/DesignContext';

interface Testimonial {
  quoteIcon: string;
  text: string;
  rating: number;
  author: string;
  role: string;
}

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
  design?: any;
}

export default function TestimonialsSection({ testimonials, design: propDesign }: TestimonialsSectionProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const testimonialsArray = Array.isArray(testimonials) ? testimonials : [];

  const primaryColor = design?.colors?.primary || '#E07A5F';
  const bodyFont = design?.typography?.bodyFont || "'Plus Jakarta Sans', sans-serif";
  const headingFont = design?.typography?.headingFont || "'Sora', sans-serif";
  const textColor = design?.colors?.text || '#1E1E1E';
  const containerMaxWidth = design?.spacing?.containerMaxWidth || '1200px';

  const quoteIconStyle: React.CSSProperties = {
    filter: `brightness(0) saturate(100%) invert(40%) sepia(80%) saturate(500%) hue-rotate(${
      primaryColor === '#E07A5F' ? '340deg' : '0deg'
    })`, // approximative tint – better to use inline color filter or simply keep original
    // Alternatively, use a simple background color wrapper:
    // backgroundColor: primaryColor,
    // borderRadius: '50%',
  };
  const starStyle: React.CSSProperties = {
    color: primaryColor,
    marginRight: '0.2rem',
  };
  const authorStyle: React.CSSProperties = {
    color: primaryColor,
    fontFamily: headingFont,
    fontWeight: 'bold',
  };
  const textStyle: React.CSSProperties = {
    fontFamily: bodyFont,
    color: textColor,
    fontSize: '1.1rem',
    lineHeight: 1.6,
  };
  const sectionStyle: React.CSSProperties = {
    padding: '60px 0',
  };

  if (testimonialsArray.length === 0) {
    return (
      <section className="testimonials" style={sectionStyle}>
        <div className="container" style={{ maxWidth: containerMaxWidth, margin: '0 auto' }}>
          <p className="text-center">Aucun témoignage pour le moment.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="testimonials" style={sectionStyle}>
      <div className="container" style={{ maxWidth: containerMaxWidth, margin: '0 auto' }}>
        <div className="row">
          <div className="col-12">
            <Swiper modules={[Autoplay]} autoplay={{ delay: 5000 }} loop className="testimonialSwiper">
              {testimonialsArray.map((test, idx) => (
                <SwiperSlide key={idx}>
                  <div className="testimonials-content" style={{ textAlign: 'center', padding: '1rem' }}>
                    <div style={quoteIconStyle}>
                      <Image src={test.quoteIcon} alt="" width={50} height={50} />
                    </div>
                    <h4 data-aos="fade-up" style={textStyle}>{test.text}</h4>
                    <p data-aos="fade-up" style={textStyle}>{test.text}</p>
                    <ul className="rating" style={{ display: 'flex', justifyContent: 'center', listStyle: 'none', padding: 0 }}>
                      {Array.from({ length: test.rating }).map((_, i) => (
                        <li key={i} style={starStyle}><i className="fa fa-star"></i></li>
                      ))}
                    </ul>
                    <h5 data-aos="fade-up" style={authorStyle}>{test.author} - {test.role}</h5>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}